import React, { useEffect, useState } from "react";
import TabSelection from "../../../components/commons/TabSelection";
import { onBoardingMenu } from "./data";
import RenderScreen from "./RenderScreen";
import SearchingInput from "../../../components/commons/SearchingInput";
import { connect } from "react-redux";
import { useLocation } from "react-router";

const MainPage = ({ token }) => {
  const [menuType, setMenuType] = useState("Pending");
  const [currentPage, setCurrentPage] = useState(1);
  const [orderFilter, setOrderFilter] = useState("ASC");
  const [searching, setSearching] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [onForcedStatus, setOnForcedStatus] = useState("");
  const [readyForSearch, setReadyForSearch] = useState(false);

  const location = useLocation();
  const { status, page } = location.state || {};

  // When user types, wait before applying it
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searching);
      if (readyForSearch) {
        setCurrentPage(1);
      }
    }, 500);

    // Cleanup on every re-run
    return () => {
      clearTimeout(handler);
    };
  }, [searching]);

  useEffect(() => {
    setReadyForSearch(false);
    if (status && page) {
      setMenuType(status);
      setCurrentPage(page);
      setOnForcedStatus(status);
      setReadyForSearch(true);
    } else {
      setReadyForSearch(true);
    }
  }, []);

  return (
    <div>
      {/* tab menu start  */}
      <div className="">
        <div className="flex justify-content-between align-item-center">
          <div>
            <TabSelection
              menu={onBoardingMenu}
              defaultSelected={menuType}
              onForceChanged={onForcedStatus}
              onMenuChange={(tab) => {
                setMenuType(tab?.value);
                setCurrentPage(1);
              }}
            />
          </div>
          <div className="flex gap-12 align-item-end">
            <div className="input-field-sm">
              <p className="font-500 font-12 mb-6 m-0">Order By</p>
              <select
                value={orderFilter}
                onChange={(e) => {
                  setOrderFilter(e.target.value);
                  setCurrentPage(1);
                }}
                className="cursor-pointer"
              >
                <option value="ASC">Ascending</option>
                <option value="DESC">Descending</option>
              </select>
            </div>
            <div>
              <SearchingInput
                onSearching={(value) => {
                  setSearching(value);
                  // setCurrentPage(1);
                }}
              />
            </div>
            <div>
              <p className="">
                {totalRecords} {menuType}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* tab menu end   */}
      <div className="bg-white border-radius-8 mt-28">
        <RenderScreen
          token={token}
          menuType={menuType}
          currentPage={currentPage}
          orderFilter={orderFilter}
          setCurrentPage={setCurrentPage}
          searching={debouncedSearch}
          setTotalRecords={setTotalRecords}
        />
      </div>
    </div>
  );
};

const mapState = (state) => ({
  token: state.userInfo.token,
});

const mapDispatch = {};

export default connect(mapState, mapDispatch)(MainPage);
// export default MainPage;
